import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { NotFound } from "@app/shared/ErrorPages";

import { AccuracyTemplateDetailsView, TemplateDetailsView } from "./view";
import { JSX } from "react";

/** Renders the routing components for the projects sub-section of the app. */
export default function TemplatesRouter(props: RouteComponentProps): JSX.Element {
  return (
    <Switch>
      <Route path={`${props.match.path}/adequacy/:templateCollectionId/:templateId`} component={TemplateDetailsView} />
      <Route path={`${props.match.path}/accuracy/:templateCollectionId/:templateId`} component={AccuracyTemplateDetailsView} />
      <Route component={NotFound} />
    </Switch>
  );
}
